import React from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  DatePicker,
  FormInput,
  FormSelect,
  FormTextarea,
  Button,
} from "shards-react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import { TiEdit,TiDeleteOutline } from "react-icons/ti";
import ProjectDataService from "../../services/project.service";
import { FcPlus } from "react-icons/fc";
import nav_store, {
  types as nav_types,
  actions as nav_actions,
} from "../../_stores/sidenav.store";

// const productApiKeys = ['VER_VENDORID',
//                         'RETAILER_ID',
//                         'DATA_TYPE',
//                         'COMP_CODE',
//                         'COMP_NAME',
//                         'SALT_NAME',
//                         'DRUG_TYPE',
//                         'PROD_CODE',
//                         'BAR_CODE',
//                         'PROD_NAME',
//                         'PACK_SIZE',
//                         'CONVERSION',
//                         'UOM',
//                         'PUR_RATE',
//                         'MRP',
//                         'HSNCODE',
//                         'GST',
//                         'REMARK'];
// const sasApiKeys = [
//                     'RECORD_TYPE',
//                     'VER_VENDORID',
//                     'RETAILER_ID',
//                     'DATA_TYPE',
//                     'PERIOD_START_DATE',
//                     'PERIOD_END_DATE',
//                     'CREATED_DATE',
//                     'CREATED_TIME',
//                     'PROD_CODE',
//                     'BAR_CODE',
//                     'COMP_NAME',
//                     'PROD_NAME',
//                     'OPENING_STOCK',
//                     'GOODS_RECEIVED',
//                     'OPENING_STOCK',
//                     'GOODS_RECEIVED',
//                     'GOODS_RECEIVED_FREE',
//                     'SALES_RETURN',
//                     'SALES_RETURN_FREE',
//                     'PURCHASE_RETURN',
//                     'PURCHASE_RETURN_FREE',
//                     'SALES_QTY',
//                     'SALES_FREE_QTY',
//                     'ADJUSTMENTS',
//                     'CLOSING_STOCK',
//                     'CONVERSION',
//                     'UOM',
//                     'PUR_RATE',
//                     'MRP',
//                     'EXPIRED',
//                     'EXP_UPTO_90',
//                     'Remark'  
//                   ];

class EditProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectName: "",
      startDate: undefined,
      countryName: "",
      asset: "",
      fileFormat: "",
      fileDescription: "",
      masterApiKeys:"",
      fileNamingConvention: "",
      maxNumOfFiles: "",
      isMandatoryFile: true,
      dataFrequencyByFileType: "",
      serverPath: "",
      serverUserName: "",
      serverPassword: "",
      serverPortNumber: "",
      serverFolderPath: "",
      showModal:false,
      localStoreData : [],
      fieldName:"",
      apiKey:"",
      apiKeyArray:[],
      dataType:"",
      localStoreFieldData: [],
      updateId:false,
      formFieldId:"",
    };

    this.state.localStoreData = JSON.parse(
      localStorage.getItem("addFormDataArr")
    );
    this.state.localStoreFieldData = JSON.parse(
      localStorage.getItem("addFieldDataArr")
    );

    this.onChangeProjectName = this.onChangeProjectName.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.onChangeCountryName = this.onChangeCountryName.bind(this);
    this.onChangeAsset = this.onChangeAsset.bind(this);
    this.onChangeFileFormat = this.onChangeFileFormat.bind(this);
    this.onChangeFileDescription = this.onChangeFileDescription.bind(this);
    this.onChangeMasterApiKeys = this.onChangeMasterApiKeys.bind(this);
    this.onChangeFileNamingConvention = this.onChangeFileNamingConvention.bind(this);
    this.onChangeMaxNumOfFiles = this.onChangeMaxNumOfFiles.bind(this);
    this.onChangeIsMandatoryFile = this.onChangeIsMandatoryFile.bind(this);
    this.onChangeDataFrequencyByFileType = this.onChangeDataFrequencyByFileType.bind(this);
    this.onChangeServerPath = this.onChangeServerPath.bind(this);
    this.onChangeServerUserName = this.onChangeServerUserName.bind(this);
    this.onChangeServerPassword = this.onChangeServerPassword.bind(this);
    this.onChangeServerPortNumber = this.onChangeServerPortNumber.bind(this);
    this.onChangeServerFolderPath = this.onChangeServerFolderPath.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleAddFileForm = this.handleAddFileForm.bind(this);
    this.handleAddFieldForm = this.handleAddFieldForm.bind(this);
    this.onChangeFieldName = this.onChangeFieldName.bind(this);
    this.onChangeApiKey = this.onChangeApiKey.bind(this);
    this.onChangeDataType = this.onChangeDataType.bind(this);
    this.handleAddProjectForm = this.handleAddProjectForm.bind(this);
    this.handleEditFieldForm = this.handleEditFieldForm.bind(this);
    this.handleUpdateProjectBasicForm = this.handleUpdateProjectBasicForm.bind(this);
    this.handleNewFileInEdit = this.handleNewFileInEdit.bind(this);
    this.handleUpdateFileForm = this.handleUpdateFileForm.bind(this);

  }

  componentDidMount() {
    if(this.props.projectId)
    this.retrieveProjectDetails();
  }

  retrieveProjectDetails(){
    //alert();

    this.setState({
      localStoreData : [],
      localStoreFieldData: [],
    })
    localStorage.removeItem("addFormDataArr");
    localStorage.removeItem("addFieldDataArr");

    ProjectDataService.get(this.props.projectId).then((response) => {
      var projectDetails = response.data.data;

      localStorage.setItem('addFormDataArr', JSON.stringify(projectDetails.files))
     
      this.setState({
        projectDetails: projectDetails,
        projectName: projectDetails.projectName,
        dataSendToApi: projectDetails.dataSendToApi,
        dataSendToDatabase: projectDetails.dataSendToDatabase,
       // apiDetails:
        //dbServerDetails:
        startDate: projectDetails.startDate,
        countryName: projectDetails.countryName,
        asset: projectDetails.asset,
        serverPath: projectDetails.serverPath,
        serverFolderPath: projectDetails.serverFolderPath,
        serverUserName: projectDetails.serverUserName,
        serverPassword: projectDetails.serverPassword,
        serverPortNumber: projectDetails.serverPortNumber,
        masterKeys: projectDetails.masterKeys,
        files:projectDetails.files,
        localStoreData: JSON.parse(localStorage.getItem("addFormDataArr")),
      });
      
    });
  }

  handleEditFieldForm(id){
    var files = this.state.projectDetails.files;
    var filteredFileEdit = files.filter(function (item) {
      return (item._id === id)
    })
   
   var filterMasterKey = this.state.masterKeys;
   
   var filterMasterArray = filterMasterKey.filter(function (item) {
     if(item.masterKeyName === filteredFileEdit[0].masterApiKeys){
      return item.masterKeyFields;
     }
   })
   this.setState({
     apiKeyArray: filterMasterArray[0].masterKeyFields,
   });



   localStorage.setItem('addFieldDataArr', JSON.stringify(filteredFileEdit[0].masterTableFields));
    var masterKeys = this.state.masterKeys;
    this.setState({
      formFieldId : id,
      fileFormat : filteredFileEdit[0].fileFormat,
      fileDescription : filteredFileEdit[0].fileDescription,
      masterApiKeys : filteredFileEdit[0].masterApiKeys,
      fileNamingConvention : filteredFileEdit[0].fileNamingConvention,
      maxNumOfFiles : filteredFileEdit[0].maxNumOfFiles,
      isMandatoryFile : filteredFileEdit[0].isMandatoryFile,
      dataFrequencyByFileType : filteredFileEdit[0].dataFrequencyByFileType,
      localStoreFieldData: JSON.parse(localStorage.getItem("addFieldDataArr")),
      masterKeys: masterKeys,
      showModal: true,
      updateId:true
    });

  } 

  handleNewFileInEdit(){
    localStorage.removeItem("addFieldDataArr");
    this.setState({
      showModal: true,
      updateId:false,
    });
  }

  onChangeProjectName(e) {
    this.setState({
      projectName: e.target.value,
    });
  }

  handleStartDateChange(value) {
    this.setState({
      ...this.state,
      ...{ startDate: new Date(value) },
    });
  }

  onChangeCountryName(e) {
    this.setState({
      countryName: e.target.value,
    });
  }

  onChangeAsset(e) {
    this.setState({
      asset: e.target.value,
    });
  }

  onChangeFileFormat(e) {
    this.setState({
      fileFormat: e.target.value,
    });
  }

  onChangeFileDescription(e) {
    this.setState({
      fileDescription: e.target.value,
    });
  }

  onChangeMasterApiKeys(e) {
    this.setState({
      masterApiKeys: e.target.value,
    });
    
    var filterMasterKey = this.state.masterKeys;
    
    var filterMasterArray = filterMasterKey.filter(function (item) {
      if(item.masterKeyName === e.target.value){
       return item.masterKeyFields;
      }
    })
    this.setState({
      apiKeyArray: filterMasterArray[0].masterKeyFields,
    });

    localStorage.removeItem("addFieldDataArr");
    this.setState({
      localStoreFieldData: [],
    });
  }

  onChangeFileNamingConvention(e) {
    this.setState({
      fileNamingConvention: e.target.value,
    });
  }

  onChangeMaxNumOfFiles(e) {
    this.setState({
      maxNumOfFiles: e.target.value,
    });
  }

  onChangeIsMandatoryFile(e) {
    this.setState({
      isMandatoryFile: e,
    });
  }

  onChangeDataFrequencyByFileType(e) {
    this.setState({
      dataFrequencyByFileType: e.target.value,
    });
  }

  onChangeServerPath(e) {
    this.setState({
      serverPath: e.target.value,
    });
  }

  onChangeServerUserName(e) {
    this.setState({
      serverUserName: e.target.value,
    });
  }

  onChangeServerPassword(e) {
    this.setState({
      serverPassword: e.target.value,
    });
  }

  onChangeServerPortNumber(e) {
    this.setState({
      serverPortNumber: e.target.value,
    });
  }

  onChangeServerFolderPath(e) {
    this.setState({
      serverFolderPath: e.target.value,
    });
  }

  handleShowModal() {
    this.setState({
      showModal: true,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
      localStoreFieldData: [],
      fileFormat: "",
      fileDescription: "",
      fileNamingConvention: "",
      maxNumOfFiles: "",
      isMandatoryFile: false,
      dataFrequencyByFileType: "",
      fieldName: "",
      dataType: "",
    });
  }

  handleAddFileForm() {
    // alert();

    var addFormDataArr = [];
    var addFieldDataArr = [];

    
    if (localStorage.getItem("addFormDataArr"))
      addFormDataArr = JSON.parse(localStorage.getItem("addFormDataArr"));

    if (localStorage.getItem("addFieldDataArr"))
      addFieldDataArr = JSON.parse(localStorage.getItem("addFieldDataArr"));

    localStorage.removeItem("addFormDataArr");
    
    //this is for getting dbserver details and api details from master table keys
    var masterKeys = this.state.masterKeys;
    var selectedMasterApiKeys = this.state.masterApiKeys;
    var dbServerDetails = {};
    var apiDetails = {};
    masterKeys.filter(function (item) {
     if(item.masterKeyName === selectedMasterApiKeys){
        dbServerDetails.dbHostURL = item.dbHostURL;
        dbServerDetails.dbName = item.dbName;
        dbServerDetails.dbUserName = item.dbUserName;
        dbServerDetails.dbPassword = item.dbPassword;
        dbServerDetails.dbTableName = item.dbTableName;
        apiDetails.isApiAuthenticated = item.isApiAuthenticated;
        apiDetails.loginInputData = item.loginInputData;
        apiDetails.apiURL =  item.apiURL;
        apiDetails.authHeaderData =  item.authHeaderData;
     }
    });

    var addFormData = {
      fileFormat: this.state.fileFormat,
      fileDescription: this.state.fileDescription,
      masterApiKeys : this.state.masterApiKeys,
      dbServerDetails : dbServerDetails,
      apiDetails : apiDetails,
      dataSendToApi: this.state.dataSendToApi,
      dataSendToDatabase: this.state.dataSendToDatabase,
      fileNamingConvention: this.state.fileNamingConvention,
      maxNumOfFiles: this.state.maxNumOfFiles,
      isMandatoryFile: this.state.isMandatoryFile,
      dataFrequencyByFileType: this.state.dataFrequencyByFileType,
      masterTableFields: addFieldDataArr,
    };

    addFormDataArr.push(addFormData);
    localStorage.setItem("addFormDataArr", JSON.stringify(addFormDataArr));
    this.setState({
      localStoreData: JSON.parse(localStorage.getItem("addFormDataArr")),
    });

    var projectDetails = this.state.projectDetails;
    projectDetails.files.push(addFormData);

    ProjectDataService.update(this.props.projectId, projectDetails)
    .then((response) => {
      if(response.data.success){ // check for success
        this.newProjectForm();
        var notify_message =({
          type:"success",
          message:"Project has been Updated successfully."
        });
      }else{
        if(response.data.err.message){ // fields error
          var notify_message =({
            type:"error",
            message:response.data.err.message
          });
        }
        else{ // mongo error
          var notify_message =({ 
            type:"error",
            message:response.data.err.name + " - May be duplicate Records"
          });
        }
      }
      this.props.redirectToProjectDetails("/project/" + this.props.projectId ,notify_message);
    });


    localStorage.removeItem("addFieldDataArr");
    this.handleCloseModal();
  }




  handleUpdateFileForm(){
    
    var addFormDataArr = [];
    var addFieldDataArr = [];

    if (localStorage.getItem("addFormDataArr"))
      addFormDataArr = JSON.parse(localStorage.getItem("addFormDataArr"));

    if (localStorage.getItem("addFieldDataArr"))
      addFieldDataArr = JSON.parse(localStorage.getItem("addFieldDataArr"));

    localStorage.removeItem("addFormDataArr");

     //this is for getting dbserver details and api details from master table keys
     var masterKeys = this.state.masterKeys;
     var selectedMasterApiKeys = this.state.masterApiKeys;
     var dbServerDetails = {};
     var apiDetails = {};
     masterKeys.filter(function (item) {
      if(item.masterKeyName === selectedMasterApiKeys){
         dbServerDetails.dbHostURL = item.dbHostURL;
         dbServerDetails.dbName = item.dbName;
         dbServerDetails.dbUserName = item.dbUserName;
         dbServerDetails.dbPassword = item.dbPassword;
         dbServerDetails.dbTableName = item.dbTableName;
         apiDetails.isApiAuthenticated = item.isApiAuthenticated;
         apiDetails.loginInputData = item.loginInputData;
         apiDetails.apiURL =  item.apiURL;
         apiDetails.authHeaderData =  item.authHeaderData;
      }
     });

    var addFormData = {
      _id:this.state.formFieldId,
      fileFormat: this.state.fileFormat,
      fileDescription: this.state.fileDescription,
      masterApiKeys : this.state.masterApiKeys,
      dbServerDetails : dbServerDetails,
      apiDetails : apiDetails,
      dataSendToApi: this.state.dataSendToApi,
      dataSendToDatabase: this.state.dataSendToDatabase,
      fileNamingConvention: this.state.fileNamingConvention,
      maxNumOfFiles: this.state.maxNumOfFiles,
      isMandatoryFile: this.state.isMandatoryFile,
      dataFrequencyByFileType: this.state.dataFrequencyByFileType,
      masterTableFields: addFieldDataArr
    };

    // formFieldId
    var projectDetails = this.state.projectDetails;
    projectDetails.files.filter(function (item) {
     if(item._id === addFormData._id){
      item.fileFormat = addFormData.fileFormat;
      item.fileDescription = addFormData.fileDescription;
      item.masterApiKeys = addFormData.masterApiKeys;
      item.dbServerDetails = addFormData.dbServerDetails;
      item.apiDetails = addFormData.apiDetails;
      item.dataSendToApi = addFormData.dataSendToApi;
      item.dataSendToDatabase = addFormData.dataSendToDatabase;
      item.fileNamingConvention =addFormData.fileNamingConvention;
      item.maxNumOfFiles = addFormData.maxNumOfFiles;
      item.isMandatoryFile = addFormData.isMandatoryFile;
      item.dataFrequencyByFileType = addFormData.dataFrequencyByFileType;
      item.masterTableFields = addFormData.masterTableFields;
    }

   })

    ProjectDataService.update(this.props.projectId, projectDetails)
      .then((response) => {
        if(response.data.success){ // check for success
          this.newProjectForm();
          var notify_message =({
            type:"success",
            message:"Project has been Updated successfully."
          });
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:response.data.err.name + " - May be duplicate Records"
            });
          }
        }
        this.props.redirectToProjectDetails("/project/" + this.props.projectId ,notify_message);
      });

  }


  

  onChangeFieldName(e) {
    this.setState({
      fieldName: e.target.value,
    });
  }

  onChangeApiKey(e) {
    this.setState({
      apiKey: e.target.value,
    });
  }

  onChangeDataType(e) {
		this.setState({
			dataType: e.target.value,
		});
	}

  handleAddFieldForm() {
    // alert();
     
     var addFieldDataArr=[]; 
 
   
     if(localStorage.getItem("addFieldDataArr"))
     addFieldDataArr = JSON.parse(localStorage.getItem("addFieldDataArr"));
 
     localStorage.removeItem("addFieldDataArr");
     
     var addFieldata = {
       fieldName: this.state.fieldName,
       apiKey: this.state.apiKey,
       dataType: this.state.dataType
     }
     
     addFieldDataArr.push(addFieldata);
     localStorage.setItem('addFieldDataArr', JSON.stringify(addFieldDataArr));
     this.setState({
      localStoreFieldData: JSON.parse(localStorage.getItem("addFieldDataArr")),
      fieldName:"",
      apiKey: "",
     });
   }

  newProjectForm() {
    this.setState({
      projectName: "",
      startDate: "",
      countryName: "",
      asset: "",
      serverPath: "",
      serverUserName: "",
      serverPassword: "",
      serverPortNumber: "",
      serverFolderPath: "",
      files: "",
      localStoreData: [],
    });
  }

  handleAddProjectForm() {
    if (localStorage.getItem("addFormDataArr"))
      var addFormDataArr = JSON.parse(localStorage.getItem("addFormDataArr"));

    var data = {
      projectName: this.state.projectName,
      startDate: this.state.startDate,
      countryName: this.state.countryName,
      asset: this.state.asset,
      serverPath: this.state.serverPath,
      serverUserName: this.state.serverUserName,
      serverPassword: this.state.serverPassword,
      serverPortNumber: this.state.serverPortNumber,
      serverFolderPath: this.state.serverFolderPath,
      files: addFormDataArr,
    };
    
    ProjectDataService.create(data)
    .then((response) => {
      if(response.data.success){ // check for success
        this.newProjectForm();
        var notify_message =({
          type:"success",
          message:"Project has been created successfully."
        });
        localStorage.removeItem("addFormDataArr");
        nav_actions.setSideNav(nav_store.dispatch, {});

      }else{
        if(response.data.err.message){ // fields error
          var notify_message =({
            type:"error",
            message:response.data.err.message
          });
        }
        else{ // mongo error
          var notify_message =({ 
            type:"error",
            message:response.data.err.name + " - May be duplicate record"
          });
        }
      }
      this.props.redirectToProjectDetails("/project/" + response.data.data.id, notify_message);
    })
  }

  handleUpdateProjectBasicForm() {
    
    var data = {
      projectName: this.state.projectName,
      startDate: this.state.startDate,
      countryName: this.state.countryName,
      asset: this.state.asset,
      serverPath: this.state.serverPath,
      serverUserName: this.state.serverUserName,
      serverPassword: this.state.serverPassword,
      serverPortNumber: this.state.serverPortNumber,
      serverFolderPath: this.state.serverFolderPath,
      productFieldKeys:this.state.productFieldKeys,
      sasFieldKeys:this.state.sasFieldKeys
    };
    
    ProjectDataService.update(this.props.projectId, data)
      .then((response) => {
        if(response.data.success){ // check for success
          this.newProjectForm();
          var notify_message =({
            type:"success",
            message:"Project has been Updated successfully."
          });
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:response.data.err.name + " - May be duplicate Records"
            });
          }
        }
        this.props.redirectToProjectDetails("/project/" + this.props.projectId ,notify_message);
      });
  }


  deleteFromLocalStorage(fieldNameData){
   // alert(fieldNameData);
    let data = JSON.parse(localStorage.getItem("addFieldDataArr"))
    let deleteindex;
    // Get index of object
     data.find(function(item, i){
      
      if(item.fieldName == fieldNameData){
        deleteindex = i;
       // 
      }
    });

    data.splice(deleteindex, 1)
    // Splice the array at the index of your object
   
    // Save back to localStorage
    localStorage.setItem("addFieldDataArr", JSON.stringify(data)); 
    this.setState({
      localStoreFieldData: JSON.parse(localStorage.getItem("addFieldDataArr"))
     });
  }


  render() {
    const {
         showModal,
        localStoreData,
        localStoreFieldData,
        masterKeys,
        files,
        apiKeyArray,
    } = this.state;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Edit Project</h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Project Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {this.state.projectName}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Start Date</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <DatePicker
                          selected={this.state.startDate && new Date(this.state.startDate)}
                          onChange={this.handleStartDateChange}
                          placeholderText="Start Date"
                          dropdownMode="select"
                          className="text-center col-md-12"
                          md="8"
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Country Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="feName"
                          placeholder="Country Name"
                          value={this.state.countryName}
                          onChange={this.onChangeCountryName}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">Asset</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="feName"
                          placeholder="Asset"
                          value={this.state.asset}
                          onChange={this.onChangeAsset}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">
                          File Location Configuration
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <FormInput
                              id="serverPath"
                              placeholder="Server Path"
                              value={this.state.serverPath}
                              onChange={this.onChangeServerPath}
                            />
                          </Col>
                          <Col className="form-field" md="3">
                            <FormInput
                              id="serverPortNumber"
                              placeholder="Port"
                              value={this.state.serverPortNumber}
                              onChange={this.onChangeServerPortNumber}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="serverUsername"
                              placeholder="Server User Name"
                              value={this.state.serverUserName}
                              onChange={this.onChangeServerUserName}
                            />
                          </Col>
                          <Col className="form-field" md="6">
                            <FormInput
                              id="serverPassword"
                              type="password"
                              placeholder="Server Password"
                              value={this.state.serverPassword}
                              onChange={this.onChangeServerPassword}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="form-field" md="12">
                            <FormInput
                              id="folderPath"
                              placeholder="Folder Path"
                              value={this.state.serverFolderPath}
                              onChange={this.onChangeServerFolderPath}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {masterKeys &&
                    masterKeys.map(
                      (masterItem, masterIndex) => {
                        return (
                          <Row className="form-group-row" key={masterIndex + 1}>
                            <Col className="form-label" md="4">
                              <label htmlFor="feFirstName">
                                    {masterItem.masterKeyName}
                              </label>
                            </Col>
                            <Col className="form-field" md="8">
                              <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                <Col className="form-label" md="5">
                                  Field Name
                                </Col>
                                <Col className="form-label" md="3">
                                  Data Type
                                </Col>
                                <Col className="form-label" md="2">
                                  Required
                                </Col>
                                <Col className="form-label" md="2">
                                  Primary
                                </Col>
                              </Row>
                              {masterItem.masterKeyFields &&
                              masterItem.masterKeyFields.map(
                                (masterFieldItem, masterFieldIndex) => {
                                  return (
                                    <Row
                                      className="form-group-row border-bottom-button ml-2 mr-2"
                                      key={masterFieldIndex + 1}
                                    >
                                      <Col className="form-field" md="5">
                                        {masterFieldItem.fieldName}
                                      </Col>
                                      <Col className="form-field" md="3">
                                        {masterFieldItem.dataType}
                                      </Col>
                                      <Col className="form-field" md="2">
                                        {masterFieldItem.isRequired === true ? "Yes" : "No"}
                                      </Col>
                                      <Col className="form-field" md="2">
                                        {masterFieldItem.isPrimaryKey === true ? "Yes" : "No"}
                                      </Col>
                                    </Row>
                                  );
                                }
                              )}
                              <Row className="form-group-row mt-3">
                                <Col className="form-label" md="3">
                                  <label htmlFor="">Has Associated Table ?</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="9">
                                  {masterItem.hasAssociatedTable ? "YES" : "NO"}
                                </Col>
                              </Row>
                              {masterItem.hasAssociatedTable ? (
                                <>
                                  <Row className="form-group-row customized-01">
                                    <Col className="form-label" md="3">
                                      <label htmlFor="">Associated Table Name</label>
                                    </Col>
                                    <Col className="form-field flx-items-center" md="9">
                                      {masterItem.associatedTableName}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                    <Col className="form-label" md="5">
                                      Table Field Name
                                    </Col>
                                    <Col className="form-label" md="3">
                                      Data Type
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Required
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Primary
                                    </Col>
                                  </Row>
                                  {masterItem.associatedKeyFields &&
                                    masterItem.associatedKeyFields.map((mtItem, mtIndex) => {
                                      return (
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2" key={mtIndex + 1}>
                                          <Col className="form-field" md="5">
                                            {mtItem.fieldName}
                                          </Col>
                                          <Col className="form-field" md="3">
                                            {mtItem.dataType}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isRequired === true ? "Yes" : "No"}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                </>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                          );
                        }
                      )}
                   
                    <Row  className="form-group-row">
                      <Col className="form-button" md="4">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={this.handleUpdateProjectBasicForm}
                        >
                          <FcPlus /> Update Project
                        </Button>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-field font-bold" md="12">
                        <label htmlFor="feFirstName">Files Required</label>
                        <Button
                          className="ml-3"
                          variant="primary"
                          onClick={this.handleNewFileInEdit}
                        >
                          <FcPlus /> Add Files
                        </Button>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Accordion>
                      {localStoreData &&
                          localStoreData.map((item, index) => {
                            return (
                              <Accordion.Item
                                eventKey={index + 1}
                                datakey={index + 1}
                                key={index + 1}
                              >
                                <Accordion.Header>
                                  <a variant="primary" className=" ml-2 btn btn-primary" onClick={() => this.handleEditFieldForm(item._id)}><TiEdit size="14"/> Edit</a>
                                  <div className=" ml-3">File {index + 1} - {item.fileFormat}</div>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        File Format
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileFormat}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Files Description
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileDescription}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Master Api Keys
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.masterApiKeys}
                                      </Col>
                                    </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        File Naming Convention
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.fileNamingConvention}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Maximum Number of Files
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.maxNumOfFiles}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Mandatory Files
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.isMandatoryFile === true ? "Yes" : "No"}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="feFirstName">
                                        Data Frequency By File Type
                                      </label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      {item.dataFrequencyByFileType}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button">
                                    <Col
                                      className="form-field font-bold"
                                      md="12"
                                    >
                                      <label htmlFor="feFirstName">
                                        Master Transaction Fields
                                      </label>
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button">
                                      <Col className="form-label" md="4">
                                       Field Name
                                      </Col>
                                      <Col className="form-label" md="4">
                                        Master key
                                      </Col>
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Data Type
                                        </label>
                                      </Col>
                                  </Row>
                                  {item.masterTableFields &&
                                    item.masterTableFields.map(
                                      (mtItem, mtIndex) => {
                                        return (
                                          <>
                                            <Row className="form-group-row border-bottom-button" key={mtIndex + 1}>
                                              <Col className="form-field" md="4">
                                                {mtItem.fieldName}
                                              </Col>
                                              <Col className="form-field" md="4">
                                                {mtItem.apiKey}
                                              </Col>
                                              <Col className="form-field" md="4">
                                                {mtItem.dataType}
                                              </Col>
                                            </Row>
                                        </>
                                        );
                                      }
                                    )}

                                        <Row className="mt-2">
                                          <Button variant="primary" className=" ml-2" onClick={() => this.handleEditFieldForm(item._id)}><TiEdit size="16"/> Edit</Button>
                                          {/* <Button variant="primary" className="ml-3" onClick={this.handleAddFileForm}><TiDeleteOutline size="16" /> Delete</Button> */}
                                      </Row>
                                 
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                      </Accordion>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>

        <Modal show={showModal} size="lg" className="filePopup" onHide={this.handleCloseModal}>
          <Modal.Header>
            <Modal.Title>{this.state.updateId ? "Edit" : "Add"} File</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.handleCloseModal}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Format</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="fileFormat"
                    placeholder="File Format"
                    value={this.state.fileFormat}
                    onChange={this.onChangeFileFormat}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Description</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormTextarea
                    id="fileDescription"
                    placeholder="File Descriptions"
                    rows="3"
                    value={this.state.fileDescription}
                    onChange={this.onChangeFileDescription}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4"><label htmlFor="masterApiKeys">Master API Keys</label></Col>
                <Col className="form-field" md="8">
                  <FormSelect id="masterApiKeys" onChange={this.onChangeMasterApiKeys} value={this.state.masterApiKeys}>
                    <option value="masterApiKeys">Select Master API Key</option>
                    {masterKeys &&
                    masterKeys.map(
                      (masterItem, masterIndex) => {
                        return (
                          <option value={masterItem.masterKeyName} key ={masterItem+masterIndex}>{masterItem.masterKeyName}</option>
                        )
                      })
                    } 
                  </FormSelect>
                  </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">File Naming Convention</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="fileNamingConvention"
                    placeholder="(xxx/x)xxxxxxxxxxxx"
                    value={this.state.fileNamingConvention}
                    onChange={this.onChangeFileNamingConvention}
                  />
                  <div className="text-sm text-muted mt-2">
                    (xxx/x(Maste Type)xxxxxx(SupplierCode)xxxxxx(DD MM YY)<br />
                    For Product Master (PxxxxxxDDMMYY)<br />
                    For SAS Master (SASxxxxxxDDMMYY)
                  </div>
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="maxNumOfFiles">Maximum Number of Files</label>
                </Col>
                <Col className="form-field" md="8">
                  <FormInput
                    id="maxNumOfFiles"
                    placeholder="Maximum Number of Files"
                    value={this.state.maxNumOfFiles}
                    onChange={this.onChangeMaxNumOfFiles}
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">Mandatory Files</label>
                </Col>
                <Col className="form-field" md="8">
                  <BootstrapSwitchButton
                    id="isMandatoryFile"
                    checked={this.state.isMandatoryFile}
                    onlabel="Yes"
                    offlabel="No"
                    onChange={this.onChangeIsMandatoryFile}
                    // onChange={(checked) => {
                    //   this.setState({ isMandatoryFile: checked })
                    // }}
                    
                  />
                </Col>
              </Row>
              <Row className="form-group-row">
                <Col className="form-label" md="4">
                  <label htmlFor="feFirstName">
                    Data Frequency By File Type
                  </label>
                </Col>
                <Col className="form-field" md="8">
                  <FormSelect
                    id="dataFrequencyByFileType"
                    value={this.state.dataFrequencyByFileType}
                    onChange={this.onChangeDataFrequencyByFileType}
                  >
                    <option>Select Data Frequency</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </FormSelect>
                </Col>
              </Row>

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="4">
                  <label htmlFor="masterTransactionFields">Master Transaction Fields</label>
                </Col>
                <Col className="form-field" md="8">
                  <Row>
                    <Col className="form-field" md="4">
                      <FormInput
                        id="fieldName"
                        placeholder="Field Name"
                        value={this.state.fieldName}
                        onChange={this.onChangeFieldName}
                      />
                    </Col>
                    <Col className="form-field" md="4">
                      <FormSelect
                        id="apiKey"
                        onChange={this.onChangeApiKey}
                      >
                        <option>Select Master API Key</option>
                        {apiKeyArray.length > 0 && (
                         apiKeyArray.map((item, index) => (
                            <option key={index+1} value={item.fieldName}>{item.fieldName}</option>
                         ))
                        )
                      }
                      </FormSelect>
                    </Col>
                    <Col className="form-field" md="3">
                      <FormSelect
                        id="dataType"
                        onChange={this.onChangeDataType}
                      >
                        <option>Select Data Type</option>
                        <option value="Number">Number</option>
                        <option value="String">String</option>
                        <option value="Date">Date</option>
                      </FormSelect>
                    </Col>
                    <Col className="form-field" md="1">
                      <Button
                        variant="primary"
                        onClick={this.handleAddFieldForm}
                      >
                        <FcPlus /> 
                      </Button>
                    </Col>
                  </Row>
                  <Row
                      className="form-group-row ml-1 mr-1 border-bottom-button" >
                      <Col className="form-label" md="4">
                        <label htmlFor="filedName">Field Name</label>
                      </Col>
                
                      <Col className="form-label" md="4">
                        <label htmlFor="dataType">Api Key</label>
                      </Col>

                      <Col className="form-label" md="3">
                        <label htmlFor="dataType">Data Type</label>
                      </Col>
                      
                      <Col className="form-label" md="1">
                        <label htmlFor="dataType">Action</label>
                      </Col>
                  </Row>
                  {localStoreFieldData &&
                    localStoreFieldData.map((item, index) => {
                      return (
                        <Row
                          className="form-group-row ml-1 mr-1 border-bottom-button"
                          key={index + 1}
                        >
                          <Col className="form-field" md="4">
                            {item.fieldName}
                          </Col>
                          <Col className="form-field" md="4">
                            {item.apiKey}
                          </Col>
                          <Col className="form-field" md="3">
                            {item.dataType}
                          </Col>
                          <Col className="form-label" md="1">
                            <div className="closeBtn" onClick={this.deleteFromLocalStorage.bind(this, item.fieldName)} aria-label="Close">
                              <TiDeleteOutline />
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>
              <Row>
                
                {this.state.updateId ? 
                  (<Button
                    variant="primary"
                    className="mt-3"
                    onClick={this.handleUpdateFileForm}
                  >
                    <FcPlus /> Update File
                  </Button>) 
                  :
                  (
                    <Button
                  variant="primary"
                  className="mt-3"
                  onClick={this.handleAddFileForm}
                    >
                      <FcPlus /> Save File
                    </Button>
                  )
                }
              </Row>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default EditProject;
